import { FC, PropsWithChildren } from "react";
import { Flex, Box } from "@chakra-ui/react";
import SkeletonBox from "../SkeletonBox";
import SkeletonText from "../SkeletonText";

const SkeletonPageFrame: FC<PropsWithChildren> = ({ children }) => (
  <>
    <SkeletonBox h={81} />

    <Flex
      h="52px"
      alignItems="center"
      gap={2}
      px={5}
      mx="auto"
      w="100%"
      maxWidth={1200}
    >
      <SkeletonText />
      <SkeletonText />
    </Flex>

    <SkeletonBox h="1px" />

    <Box mx="auto" w="100%" maxWidth={1200} px={5} pt={[6, null, 10]} pb={6}>
      {children}
    </Box>
  </>
);

export default SkeletonPageFrame;
